import ChatEmpty from './ChatEmpty';

export default ChatEmpty;
